import {BaseContainerModel} from '../../base-container.model';
import {bl_inv_bin_ext_RowClass} from '../../../dbschema/bl_inv_bin_ext.model';

export class BinExtModel extends BaseContainerModel {
  ext: bl_inv_bin_ext_RowClass = new bl_inv_bin_ext_RowClass();
}
